<template lang="pug">
div
    a-spin.chart(v-if="loading")
    v-chart.chart(:option="option" :autoresize="true" v-else)
</template>

<script>
import VChart, {THEME_KEY} from 'vue-echarts';
import axios from 'axios';
import _ from 'lodash';
// import Chart from './Chart.vue';

export default {
    props: ['code'],
    data() {
        return {
            loading: false,
            prices: [],
            xlabels: [],
            limitUp: null,
            limitDown: null,
            timer: null,
        };
    },
    mounted() {
        this.getData();
    },
    created() {
        // 组件创建时启动定时器
        this.startTimer();
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearTimer();
    },
    methods: {
        startTimer() {
            this.clearTimer(); // 先清除旧定时器（避免重复创建）
            this.timer = setInterval(() => {
                this.getData();
            }, 6000);
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        getData() {
            axios.get(`/rtchart/${this.code}`)
                .then(res => {
                    let data = _.filter(res.data.value, i => i[1] > 0);

                    this.limitDown = res.data.limitDown;
                    this.limitUp = res.data.limitUp;

                    if (res.data.preClose) {
                        this.prices = data.map(i => (i[2] / res.data.preClose - 1)*100);
                    }

                    
                    this.xlabels = data.map(i => i[0]);
                    this.loading = false;
                })
        }
    },
    computed: {
        option() {
            let options = {
                title: {
                    text: this.code,
                    left: 'center',
                },
                grid: [
                    {height: '80%', top: '10%',  left: '55px', right: '0'},
                ],  
                xAxis: {
                    type: 'category',
                    data: this.xlabels,
                    gridIndex: 0,
                    splitLine: {
                        show: true,
        
                    },
                    axisLabel: {
                        interval: 29,
                    }
                },
                yAxis: {
                    type: 'value',
                    scale: true,
                    gridIndex: 0,
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    splitLine: {
                        show: true,
                    }
                },
                series: [
                    {
                        data: this.prices,
                        type: 'line',
                        showSymbol: false,
                        animation: false,
                        
                    }
                ]
            };

            // if (this.limitDown) {
            //     options.series.push({
            //         data: this.prices.map(i => this.limitDown),
            //         type: 'line',
            //         showSymbol: false,
            //         animation: false,
            //     });
            // }

            // if (this.limitUp) {
            //     options.series.push({
            //         data: this.prices.map(i => this.limitUp),
            //         type: 'line',
            //         showSymbol: false,
            //         animation: false,
            //     });
            // }

            return options;
        }
    },
    components: {
        VChart
    },

}
</script>

<style lang="less" scoped>
.chart {
    height: 238px;
    width: 100%;
    // margin: 5px;
}
</style>